import React, { Component } from 'react';
import { format } from 'date-fns';
import { getItemInfo } from 'components/ItemFetch';
import { SnackBarHelper } from '@lyearn-team/frontend-components';
import { certificateRequest } from './helper/requests';
import CertificateLayoutPreview from '../../admin/components/Certificate/DarkCertificatePreview';

class CertificatePreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingTemplate: true,
      certificateInfo: {}
    };
  }

  componentDidMount() {
    const certificateIssueId = this.props.params.issueId;
    if (certificateIssueId) {
      this.getCertificateDetails(certificateIssueId);
    }
  }

  getCertificateDetails = async issueId => {
    try {
      const certificateResponse = await certificateRequest(issueId);
      const certificate = await certificateResponse.json();
      if (!certificate.error) {
        const { certificateDetails, company, user, state, content } = certificate.response;
        const { certificateSettings, certificateData } = state.certificates[0];
        const { type, name } = content;
        let instructorName = '';

        if (certificateSettings.includeApprover) {
          instructorName = getItemInfo(
            'users',
            certificateData.approverId,
            'name',
            () => {
              this.forceUpdate();
            },
            '.....'
          );
        }

        const certificateInfo = {
          certificateSettings: {
            includeScore: certificateSettings.includeScore,
            includeApprover: certificateSettings.includeApprover,
            includeCompletionDate: certificateSettings.includeCompletionDate,
            dontPublishOnLinkedIn: certificateSettings.dontPublishOnLinkedIn
          },
          previewCertificateTemplate: certificateDetails.templateInfo.template,
          companyDetails: {
            companyName: company.name,
            companyImage: company.headerImage
          },
          certificateDetails: {
            activityType: type,
            activityTitle: name,
            instructorName,
            score: `${certificateData.score}%`,
            completionDate: format(certificateData.completionDate, 'Do MMMM, YYYY'),
            number: this.certificateIssueId
          },
          userDetails: {
            userName: user.name,
            emailId: user.realEmail
          },
          renderActions: false,
          closeButton: false,
          onLayoutCloseClick: () => window.history.back()
        };
        this.setState({ fetchingTemplate: false, certificateInfo });
      } else {
        SnackBarHelper.showSnackbar({
          label: 'Error while fetching certificate',
          status: 'error',
          fetchingTemplate: false
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  renderCertificate = () => {
    const { fetchingTemplate, certificateInfo } = this.state;

    if (fetchingTemplate) {
      return <CertificateLayoutPreview loading={true} />;
    }

    return <CertificateLayoutPreview loading={false} {...certificateInfo} />;
  };

  render() {
    return <React.Fragment>{this.renderCertificate()}</React.Fragment>;
  }
}

export default CertificatePreview;
